/* eslint-disable no-unused-vars */
import React from "react";

import { formatEmailTimestampToIST } from "Agentic Module/pages/emailTriaging/emailTriageUtils";
import "../../styles/emailSentUI.css";
import PropTypes from "prop-types";

function normalizeBody(value) {
  if (value == null) return "";
  return String(value)
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(/\\r\\n/g, "\n")
    .replace(/\\n/g, "\n")
    .replace(/\\r/g, "\n");
}

function normalizeRecipients(raw) {
  if (Array.isArray(raw)) return raw.filter(Boolean).map(String).join(", ");
  if (raw == null) return "";
  return String(raw)
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean)
    .join(", ");
}

function resolveSubject(email) {
  return String(email?.email_sub ?? email?.mail_subject ?? "(No subject)");
}

function resolveTimestamp(email) {
  const raw = email?.timestamp ?? "";
  return raw ? formatEmailTimestampToIST(raw) : "";
}

function resolveVariant(email) {
  const isDraft = Boolean(email?.isDraft ?? email?.is_draft);
  const isReply = Boolean(email?.isReply ?? email?.reply_all ?? email?.replyAll);
  if (isDraft) return "draft";
  if (isReply) return "reply";
  return "sent";
}

function isProbablyHtmlString(s) {
  if (!s || typeof s !== "string") return false;
  return /<[a-z][\s\S]*>/i.test(s.trim());
}

export default function EmailSentUI({
  value,
  selectedEmail,
  onReply,
  onContinueEditing,
  onDeleteDraft,
}) {
  const email = selectedEmail ?? {};
  const subject = resolveSubject(email);
  const to = normalizeRecipients(email?.email_to ?? email?.to);
  const timestamp = resolveTimestamp(email);
  const body = normalizeBody(
    email?.email_body ??
      email?.body ??
      email?.mail_content ??
      value ??
      "",
  );
  const variant = resolveVariant(email);
  const bodyIsHtml = isProbablyHtmlString(body);

  return (
    <div className="email-sent-view">
      <div className={`email-sent-card email-sent-card--${variant}`}>
        <div className="email-sent-card__header">
          <h4 className="email-sent-card__subject">{subject}</h4>
          <div className="email-sent-card__meta-row">
            <span className="email-sent-card__to">
              <span className="email-sent-card__meta-label">To:</span>{" "}
              {to || "—"}
            </span>
            <span className="email-sent-card__timestamp">{timestamp}</span>
          </div>
        </div>
        <div className="email-sent-card__body-wrap">
          {bodyIsHtml ? (
            <div
              className="email-sent-card__body email-sent-card__body--html"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: body }}
            />
          ) : (
            <div className="email-sent-card__body">{body}</div>
          )}
        </div>
      </div>

    </div>
  );
}

EmailSentUI.propTypes = {
  value: PropTypes.string,
  selectedEmail: PropTypes.object,
  onReply: PropTypes.func,
  onContinueEditing: PropTypes.func,
  onDeleteDraft: PropTypes.func,
};
